import React from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Divider, Grid, Typography } from "@mui/material";
import CardProduit from './cards/CardProduit';
import ButtonNav from './button/ButtonNav';
import ServicePrestation from '../services/ServicePrestation';
import ServiceProduit from '../services/ServiceProduit';

export default function ListeProduits() {

	let { prestationKey } = useParams();

	// Chargement des données de la prestation
	var prestation = ServicePrestation.getPrestation(prestationKey);

	// Si la prestation existe bien
	if (prestation) {

		return (

			<Grid item py={2} px={{ xs: 0, sm: 2, md: 4, lg: 20 }}>

				<Typography component="h1" sx={{ color: '#004afe', fontSize: { xs: 26, sm: 36, md: 36, lg: 54 }, fontWeight: 600 }}>
					{prestation.contenu.titre}
				</Typography>
				<Divider sx={{ backgroundColor: '#004afe', mb: 4, mt: 2, height: 3, width: 130 }} />

				<Typography component="p" sx={{ mb: 4 }}>
					{prestation.contenu.intro}
				</Typography>

				<Grid container>
					{
						// Boucle sur la liste des produits
						prestation.produits.map(function(produitKey) {

							// Chargement des données du produit
							var produit = ServiceProduit.getProduit(prestationKey, produitKey);

							if (produit) {

								return (
									<Grid key={produitKey} item xs={12} sm={6} md={4} sx={{ px: 2, pb: 4 }}>
										<CardProduit prestation={prestation} produit={produit} />
									</Grid>
								)
							} // Fin si le produit existe bien
							else {
								return null;
							}

						}) // Fin boucle sur la liste des produits

					}
				</Grid>

				<Grid container direction="row" justifyContent="center">
					<Grid item xs={12} sm={6} md={6} lg={6} xl={4} my={2} sx={{ display: 'flex', justifyContent: 'center' }}>
						<ButtonNav props={{ text: 'Retour à la liste des prestations', url: process.env.REACT_APP_CATALOGUE_URL + '/' }} />
					</Grid>
				</Grid>

				<Helmet>
					<title>{prestation.seo.title}</title>
					<meta name="description" content={prestation.seo.metaDescription} />
				</Helmet>

			</Grid>

		);

	} // Fin si la prestation existe bien

}